import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import IconButton from 'material-ui/IconButton';

import CloseIcon from 'material-ui-icons/Close';
import Dialog from 'material-ui/Dialog';
import Slide from 'material-ui/transitions/Slide';
import Card from 'material-ui/Card';
import Grid from 'material-ui/Grid';
import './ErrorBoundary.css'

import {
    addPersonalBook,
} from '../../modules/user';
import {buildDialogContent} from '../../helper/challengeRuleValidation'
function Transition (props) {
    return <Slide direction="up" {...props} />;
}

class ErrorBoundary extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            hasError: false,
            errorInfo: null,
            isDialogOpen: false,
            shouldReload: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.root && nextProps.stateError !== this.props.stateError) {
            this.setState({
                hasError: !!nextProps.stateError,
                errorInfo: nextProps.stateError,
                isDialogOpen: true,
                shouldReload: false,
            })
        }
    }

    componentDidCatch (error, info) {
        this.setState({
            hasError: true,
            isDialogOpen: true,
            errorInfo: info,
            shouldReload: true,
        });
        // code here for log the error to an error reporting service
    }

    dialogCloseHandler = () =>
        this.setState({
            isDialogOpen: false
        }, () => {
            if (this.state.shouldReload) {
                window.location.reload();
            }
        })

    submitAsChoiceBook = book => () => {
        const {title, author, bookId} = book; // only pass these, since it's a Choice book now
        this.props.addPersonalBook({title, author, bookId, isOfficial: false})
            .then(() => this.dialogCloseHandler());
    }

    render () {
        if (!this.state.hasError) {
            return this.props.children;
        }

        const {
            backdropContent,
            errorTitle,
            errorBody,
            errorActions,
            errorClass,
        } = buildDialogContent(
            this.state.errorInfo,
            this.dialogCloseHandler,
            this.submitAsChoiceBook,
            this.props.children
        );

        return <div>
            { backdropContent }
            <Dialog
                maxWidth="md"
                open={this.state.isDialogOpen}
                onClose={this.dialogCloseHandler}
                transition={Transition}>
                <div className={classnames(errorClass, "notification__dialog")}>
                    <Grid item xs={12}>
                        <Card>
                            <div className="notification__dialog--iconButton">
                                <IconButton color="default"
                                            onClick={this.dialogCloseHandler}
                                            aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                            </div>
                            <p className="notification__dialog--title">
                                { errorTitle }
                            </p>
                            <div className="notification__dialog--info">
                                <div>
                                    { errorBody }
                                </div>
                            </div>
                            <div className="notification__dialog--footer">
                                { errorActions }
                            </div>
                        </Card>
                    </Grid>
                </div>
            </Dialog>
        </div>
    }
}

const mapStateToProps = state => ({
    stateError: state.error,
})

const mapDispatchToProps = dispatch => bindActionCreators({
    addPersonalBook,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary)
